import React from "react";
import {ListItem, Paragraph, SectionHeading, UnderlinedParagraph} from "../PrivacyPolicyText";

const ChoicesAndSecuritySection = () => (
  <>
    <SectionHeading nativeID="disclose">{"Choices About How We Use and Disclose Your Information"}</SectionHeading>

    <Paragraph>
      {"We strive to provide you with choices regarding the personal information you provide to us. We have created mechanisms to provide you with the following control over your information:"}
    </Paragraph>

    <ListItem>
      {"Tracking Technologies and Advertising. You can set your browser to refuse all or some browser cookies, or to alert you when cookies are being sent. If you disable or refuse cookies, please note that some parts of this site may then be inaccessible or not function properly."}
    </ListItem>

    <ListItem>
      {"Disclosure of Your Information for Third-Party Advertising. If you do not want Us to share your personal information with unaffiliated or non-agent third parties for promotional purposes, you can opt out by checking the relevant box located on the form on which We collect your data (the order/registration form) or contact Us by email or phone. You can also always opt out by logging into the Website and adjusting your user preferences in your account profile, by checking or unchecking the relevant boxes or by sending Us an email stating your request to support@evenplay.com."}
    </ListItem>

    <ListItem withBottomMargin>
      {"Promotional Offers from the Company. If you do not wish to have your contact information used by the Company to promote our own or third parties' products or services, you can opt out by sending Us an email stating your request to support@evenplay.com. If We have sent you a promotional email, you may send Us a return email asking to be omitted from future email distributions."}
    </ListItem>

    <Paragraph>
      {"We do not control third parties' collection or use of your information to serve interest- based advertising. However, these third parties may provide you with ways to choose not to have your information collected or used in this way. You can opt out of receiving targeted ads from members of the Network Advertising Initiative (\"NAI\") on the NAI's website."}
    </Paragraph>

    <SectionHeading>{"Third Party Links On Our Site"}</SectionHeading>

    <UnderlinedParagraph>
      {"Evenplay and/or our Website may contain links to other third party websites for your convenience. We are not responsible for the privacy policies and practices of other third parties and any information you submit to a third party is subject to their privacy policy. Once you leave our Evenplay or our Website or Applications, or are otherwise redirected to a third-party website, application, or other online service, We encourage you to read the privacy Policy applicable to that third party."}
    </UnderlinedParagraph>

    <SectionHeading>{"Opt-Out Of Communications With Evenplay"}</SectionHeading>

    <UnderlinedParagraph>
      {"You may opt-out of receiving promotional e-mail communication from Us by sending Us an e-mail at support@evenplay.com, or by clicking the “unsubscribe” button at the bottom of our emails that We send to you. Please note that you will not be able to opt-out of transactional e-mail communication, such as communication related to your account activities."}
    </UnderlinedParagraph>

    <SectionHeading>{"Data Security"}</SectionHeading>

    <Paragraph>
      {"We have implemented measures designed to secure your personal information from accidental loss and from unauthorized access, use, alteration, and disclosure. All information you provide to Us is stored on our secure servers behind firewalls."}
    </Paragraph>

    <Paragraph>
      {"The safety and security of your information also depends on you. Where We have given you (or where you have chosen) a password for access to certain parts of our Service, you are responsible for keeping this password confidential. We ask you not to share your password with anyone."}
    </Paragraph>

    <Paragraph>
      {"Unfortunately, the transmission of information via the internet or other electronic method is not completely secure. Although We do our best to protect your personal information, We cannot guarantee the security of your personal information transmitted to us. Any transmission of personal information is at your own risk. We are not responsible for circumvention of any privacy settings or security measures contained on the Website."}
    </Paragraph>

    <SectionHeading nativeID="ChangesToOurPrivacyPolicy">{"Changes to Our Privacy Policy"}</SectionHeading>

    <Paragraph>
      {"It is our Policy to post any changes We make to our Privacy Policy on this page with a notice that the privacy Policy has been updated on the Website home page. If We make material changes to how We treat our users' personal information, We will notify you. The date the Privacy Policy was last revised is identified at the top of the page. You are responsible for ensuring We have an up-to-date active and deliverable email address for you, and for periodically visiting our Website and this Policy to check for any changes."}
    </Paragraph>

    <Paragraph>
      {"Nevada provides its residents with a limited right to opt-out of certain personal information sales. Residents who wish to exercise this sale opt-out rights may submit a request to this designated address: www.evenplay.com/notifications. However, please know We do not currently sell data triggering that statute's opt-out requirements."}
    </Paragraph>

    <SectionHeading>{"Contact Information"}</SectionHeading>

    <Paragraph>
      {"To ask questions or comment about this privacy Policy and our privacy practices, contact Us at: support@evenplay.com"}
    </Paragraph>
  </>
);

export default ChoicesAndSecuritySection;
